import { app } from '../../../../../../app';
import { Controller } from './send-verification-emails.controller';

app.component('companyUserDirectoriesManageGroupAccountsVerify', {
    bindings: {
        companyId: '<',
		group: '<',
    },
    controller: Controller,
    templateUrl: require('./send-verification-emails.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/verify/send-verification-emails.component.js